import React from 'react';
import { Filter, X } from 'lucide-react';
import { Button } from 'rizzui/button';

function FilterSection({
  filters,
  onFilterChange,
  onClearFilters,
  paymentMethods = []
}) {
  const handleInputChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  const hasActiveFilters = () => {
    return filters.paymentMethod ||
           filters.cashMethod;
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Filter className="h-5 w-5 text-blue-600" />
          <h3 className="text-sm font-semibold text-gray-700">Filter Records</h3>
        </div>
        {hasActiveFilters() && (
          <Button
            size="sm"
            variant="outline"
            className="text-xs h-8"
            onClick={onClearFilters}
          >
            <X className="h-3 w-3 mr-1" />
            Clear All
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {/* Cash Method Filter */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1.5">
            Cash Type
          </label>
          <select
            className="w-full h-9 text-sm px-3 py-2 bg-white border rounded-lg transition-colors border-slate-300 hover:border-slate-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500/20"
            value={filters.cashMethod || ''}
            onChange={(e) => handleInputChange('cashMethod', e.target.value)}
          >
            <option value="">All Types</option>
            <option value="cashIn">Cash In</option>
            <option value="cashOut">Cash Out</option>
          </select>
        </div>

        {/* Payment Method Filter */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1.5">
            Payment Method
          </label>
          <select
            className="w-full h-9 text-sm px-3 py-2 bg-white border rounded-lg transition-colors border-slate-300 hover:border-slate-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500/20"
            value={filters.paymentMethod || ''}
            onChange={(e) => handleInputChange('paymentMethod', e.target.value)}
          >
            <option value="">All Methods</option>
            {paymentMethods.map((method, index) => (
              <option key={index} value={method}>
                {method}
              </option>
            ))}
          </select>
        </div>
      </div>

      {hasActiveFilters() && (
        <div className="mt-3 pt-3 border-t border-gray-200">
          <div className="flex flex-wrap gap-2">
            {filters.cashMethod && (
              <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
                Type: {filters.cashMethod === 'cashIn' ? 'Cash In' : 'Cash Out'}
                <X
                  className="ml-1 h-3 w-3 cursor-pointer hover:text-blue-900"
                  onClick={() => handleInputChange('cashMethod', '')}
                />
              </span>
            )}
            {filters.paymentMethod && (
              <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
                Payment: {filters.paymentMethod}
                <X
                  className="ml-1 h-3 w-3 cursor-pointer hover:text-green-900"
                  onClick={() => handleInputChange('paymentMethod', '')}
                />
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default FilterSection;
